import { DestroyRef, inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  CarouselDialogComponent,
  CarouselDialogData
} from '@app/components/dialogs/carousel-dialog/carousel-dialog.component';
import { DeviceService } from '@app/shared/services/shared/device.service';
import { openTrackedDialog } from '@app/shared/services/shared/tracked-dialog';

/**
 * Opens the file-preview carousel without importing the feature-dialog registry.
 *
 * File list components use this focused facade so they can stay independent from
 * {@link DialogService}, which imports feature dialogs such as time reports.
 */
@Injectable({ providedIn: 'root' })
export class FilePreviewDialogService {
  private readonly matDialog = inject(MatDialog);
  private readonly deviceService = inject(DeviceService);
  private readonly destroyRef = inject(DestroyRef);

  public open(data: CarouselDialogData): MatDialogRef<CarouselDialogComponent, void> {
    const isMobile = this.deviceService.isMobile();

    return openTrackedDialog<CarouselDialogComponent, void>(this.matDialog, this.destroyRef, CarouselDialogComponent, {
      data,
      minHeight: isMobile ? '95dvh' : '90vh',
      height: isMobile ? '95dvh' : '90vh',
      minWidth: isMobile ? '95dvw' : '75vw',
      width: isMobile ? '95dvw' : '75vw'
    });
  }
}
